import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LMLogo from '../../assets/LM.svg';
import styles from './Header.module.css';

function Header() {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById('site-header-wrap');
      if (window.scrollY > 100) {
        header.classList.add(styles.shrink);
      } else {
        header.classList.remove(styles.shrink);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header id="site-header-wrap" className={styles.siteHeaderWrap}>
      <div id="site-header" className={styles.siteHeader}>
        <h1 id="site-title" className={styles.siteTitle}>
          <Link to="/">Linus Marco</Link>
        </h1>
        <div id="site-logo" className={styles.siteLogo}>
          <Link to="/">
            <img src={LMLogo} height="100%" width="100%" alt="LM Logo" />
          </Link>
        </div>
        <h3 id="about-link" className={styles.aboutLink}>
          <Link to="/about">About me</Link>
        </h3>
      </div>
    </header>
  );
}

export default Header;
